import { manageCarrierServiceTypes } from '@/common/constants'
import { returnMethods } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/constants'

export const getUpdatedCarrier = (carrier, deliveryMethod, isManualService) => {
  const isPickupPoint = deliveryMethod.type === returnMethods.pickuppoint

  if (isPickupPoint) {
    return isManualService ? { carrier } : { carrier_service: { ...carrier, supports_modification: true } }
  } else {
    return { carrier_service: { ...deliveryMethod.carrier_service, ...carrier } }
  }
}

export const getCarrierByManageCarrierService = (manageCarrierService, deliveryMethod) => {
  if (manageCarrierService === manageCarrierServiceTypes.manual) {
    return {
      carrier: { ...deliveryMethod?.carrier },
      carrier_service: null,
    }
  } else {
    return {
      carrier: null,
      carrier_service: { ...deliveryMethod?.carrier_service },
    }
  }
}
